import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { PersistentPlayerProvider } from "@/components/PersistentPlayer";
import { LanguageProvider } from "@/i18n";
import { AuthProvider } from "@/auth/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import HostSetup from "@/pages/HostSetup";
import HostGame from "@/pages/HostGame";
import JoinRoom from "@/pages/JoinRoom";
import PlayerGame from "@/pages/PlayerGame";
import RecapView from "@/pages/RecapView";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";

export default function App() {
  return (
    <div className="App bg-cream min-h-screen">
      <LanguageProvider>
        <PersistentPlayerProvider>
          <BrowserRouter>
            <AuthProvider>
              <Routes>
                {/* Public login */}
                <Route path="/login" element={<Login />} />

                {/* Host-gated routes */}
                <Route path="/" element={<ProtectedRoute><Landing /></ProtectedRoute>} />
                <Route path="/host" element={<ProtectedRoute><HostSetup /></ProtectedRoute>} />
                <Route path="/host/:code" element={<ProtectedRoute><HostGame /></ProtectedRoute>} />
                <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />

                {/* Open player routes (join via room code / QR) */}
                <Route path="/join" element={<JoinRoom />} />
                <Route path="/play/:code" element={<PlayerGame />} />
                <Route path="/recap/:code" element={<RecapView />} />
              </Routes>
            </AuthProvider>
          </BrowserRouter>
        </PersistentPlayerProvider>
      </LanguageProvider>
      <Toaster position="top-center" richColors />
    </div>
  );
}
